// transformResponse.js

import { decrypt } from "../utils/crypto"; // Função para descriptografar

export default (request, next) => {
  next(response => {
    
    // Verifica se a resposta foi recebida corretamente
    if (!response) {
    
      console.error('⚠️ Resposta não recebida ou indefinida');
      return response;  // Retorna a resposta sem alterações
    }

    // Verifique se o body da resposta existe
    if (!response.body) {
    
      console.warn('⚠️ Resposta não contém corpo (body)');
      response.body = null;  // Se o corpo da resposta não existir, definimos como null
      return response;  // Retorna a resposta sem alterações
    }

    // Verifica o tipo de conteúdo da resposta
    let data;
    let contentType = response.headers ? response.headers.get('content-type') : null;

    try {
      
      

      // Se for JSON, tenta descriptografar
      if (typeof contentType === 'string' && contentType.includes('application/json')) {
        let encryptedData = response.body;
        
        // Se os dados estiverem criptografados
        if (encryptedData) {
          // encryptedData = encryptedData.replace('X8UV43X:', ''); // Remove a parte ENCRYPTED:
          encryptedData = encryptedData.replace('ENCRYPTED:', ''); // Remove a parte ENCRYPTED:
          data = decrypt(encryptedData);  // Descriptografa os dados
          
          // Tenta converter os dados descriptografados para JSON
          data = JSON.parse(data);
        } else {
          console.warn('⚠️ Dados não criptografados ou em formato inesperado');
          data = response.body;  // Caso não esteja criptografado, usa os dados como estão
        }
      } else {
        // Caso não seja JSON, tenta processar o corpo da resposta como texto
        try {
          data = JSON.parse(response.bodyText);
        } catch (e) {
          data = null;
        }
      }

      // Remove o nível extra de aninhamento se existir
      if (data !== null && Object.prototype.hasOwnProperty.call(data, 'data') && Object.keys(data).length === 1) {
        data = data.data;
      }

      response.body = data;  // Sobrescreve o corpo da resposta com os dados finais
    } catch (error) {
      console.warn('⚠️ Falha ao processar a resposta ou descriptografar os dados:', error);
      response.body = null;  // Caso aconteça um erro, limpa o corpo da resposta
    }

    return response;  // Retorna a resposta processada
  });
};









// export default (request, next) => {
//   next(response => {
//     let data
//     let contentType = response.headers.get('content-type')
//     if (typeof contentType === 'string' && contentType.indexOf('application/json') === 0) {
//       data = response.body
//     } else {
//       try {
//         data = JSON.parse(response.bodyText)
//       } catch (e) {
//         data = null
//       }
//     }
//     // eslint-disable-next-line no-prototype-builtins
//     if (data !== null && data.hasOwnProperty('data') && Object.keys(data).length === 1) {
//       data = data.data
//     }
//     response.body = data
//     return response
//   })
// }